<template>
  <div
    :ref="
      specs
        ? get(globals, 'features.specs', 'Specs')
        : get(globals, 'features.features', 'Features')
    "
  >
    <div class="w-full md:px-gap2 lg:container features__wrapper">
      <div class="flex flex-wrap">
        <div
          class="w-[60vw] column px-gap"
          :class="length <= 2 ? 'md:w-4/12' : 'md:w-3/12'"
        ></div>
        <template v-if="product">
          <div
            v-for="(feature, index) in product"
            :key="index + 'feature'"
            class="column px-gap product__wrapper flex flex-col items-center pt-1 md:pt-4"
            :class="setColumns(feature.fields.productKey)"
          >
            <div class="max-w-[320px] text-center">
              <RichTextRenderer
                v-if="feature.fields.productInfo"
                :document="feature.fields.productInfo"
                :node-renderers="renderNodes()"
                :mark-renderers="renderMarks()"
              />
              <button
                v-if="feature.fields.productKey && feature.fields.productKey !== activeProduct.key"
                class="learn-more"
                @click="switchProductHandler(feature.fields.productKey)"
              >
                Learn more
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="bg-white header--table-fixed fixed border-b-1 w-full">
      <div class="w-full px-gap2 lg:container mt-0 md:mt-3 features__wrapper">
        <div class="flex flex-wrap -mx-gap w-full">
          <div
            class="w-12/12 column px-gap hidden md:block"
            :class="length <= 2 ? 'md:w-4/12' : 'md:w-3/12'"
          >
            <h2>
              {{
                specs
                  ? get(globals, "features.specs", "Specs")
                  : get(globals, "features.features", "Features")
              }}
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
h2 {
  color: #00263e;
  font-size: 32px;
  font-weight: bold;
}
h3 {
  color: #00263e;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 0;
  @media (max-width: 736px) {
    font-size: 20px;
  }
}
p {
  color: #00263e;
  font-size: 22px;
  font-weight: 400;
  margin-top: 0;
  @media (max-width: 736px) {
    font-size: 18px;
  }
}
.product__wrapper {
  margin: 0;
  ::v-deep {
    img {
      max-width: 274px;
      max-height: 115px;

      @media (max-width: 736px) {
        display: none;
      }
    }

    a {
      color: #0184fb;
      font-size: 20px;
      font-weight: bold;
      text-decoration: none;
      border-bottom: 2px solid #0184fb;
      margin-top: 5px;
      @media (max-width: 736px) {
        font-size: 16px;
      }
    }
  }
}
.learn-more {
  color: #0384FB;
  font-size: 18px;
  text-decoration: underline;
  margin-top: 10px;
}
.header--table-fixed {
  p {
    @apply hidden;
  }
  a.btn--blue {
    @apply hidden;
  }

  transform: translateX(-50%);
  left: 50%;
  bottom: 100%;
  transition: 0.2s ease-in-out;
  border-color: #c4c4c4;
  z-index: 99;
  opacity: 0;

  &.stuck {
    bottom: auto;
    top: 0;
    opacity: 1;
  }

  &.bottom {
    bottom: 100%;
    opacity: 0;
    top: auto;
  }
}
</style>
<script>
import get from "../mixins/get.js";
import EntryRenderer from "../modules/EntryRenderer.js";
import { WebstoreResources } from "../../../../mixins/webstore-resources"
import RichTextRenderer from "contentful-rich-text-vue-renderer";
export default {
  components: {
    RichTextRenderer,
  },
  mixins: [get, EntryRenderer, WebstoreResources],
  props: {
    product: {
      type: [Object, Array],
      required: true,
    },
    activeProduct: {
      type: Object,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
    globals: {
      type: Object,
      required: true,
    },
    specs: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
  },
  watch: {
    end: function(newValue, old) {
      this.endScroll(newValue, old);
    },
  },
  methods: {
    switchProductHandler(key) {
      this.setActiveProductKey(key);
      this.setActiveOfferKeyInactive();
			this.setActiveProductTabDefault();
			this.setBagStep(0);
    },

    handlescroll() {
      const header = this.$refs[
        this.specs
          ? this.globals.features.specs
          : this.globals.features.features
      ];
      if (header) {
        const headerFromTop =
          header.getBoundingClientRect().top +
          header.getBoundingClientRect().height / 2;
        if (0 >= headerFromTop) {
          header
            .querySelectorAll(".header--table-fixed")[0]
            .classList.add("stuck");
        } else {
          header
            .querySelectorAll(".header--table-fixed")[0]
            .classList.remove("stuck");
        }
      }
    },
    endScroll(newValue) {
      const header = this.$refs[
        this.specs
          ? this.globals.features.specs
          : this.globals.features.features
      ];
      if (header && newValue === true) {
        header
          .querySelectorAll(".header--table-fixed")[0]
          .classList.add("bottom");
      } else if (header && newValue === false) {
        header
          .querySelectorAll(".header--table-fixed")[0]
          .classList.remove("bottom");
      }
    },
    setColumns(productKey) {
      return [
        this.length === 2 ? "w-[40vw] md:w-4/12" : (this.length > 2 ? "w-[40vw] md:w-3/12" : "w-12/12 md:w-8/12"),
        this.activeProduct && (productKey === this.activeProduct.key) ? "bg-blue-light" : (this.specs ? "" : "border-r-0 border-gray-neutral-250"),
        this.specs ? "pb-3" : "",
      ];
    },
  },
};
</script>
